export const fontFamily = {
  primaryFont: "'Open Sans', sans-serif",
  secondaryFont: "'Heading Now Trial', sans-serif",
  thirdlyFont: "'Cormorant', serif;",
};
